import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'phosphor-react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-stone-50 noise-texture">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link
          to="/landing"
          className="inline-flex items-center gap-2 text-stone-600 hover:text-primary transition-colors mb-8"
          data-testid="back-home-link"
        >
          <ArrowLeft size={20} />
          Back to Home
        </Link>

        <h1 className="text-4xl font-serif font-semibold text-stone-800 mb-6" data-testid="terms-title">
          Terms of Use
        </h1>

        <div className="bg-white rounded-2xl p-8 shadow-sm space-y-6 text-stone-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-serif font-semibold text-stone-800 mb-3">Acceptance of Terms</h2>
            <p>
              By using AraVela, you agree to these terms. If you do not agree, please do not use this service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-serif font-semibold text-stone-800 mb-3">Not Medical Advice</h2>
            <p>
              <strong>AraVela is not therapy, does not provide medical advice, and does not diagnose or treat any condition.</strong>
            </p>
            <p className="mt-2">
              Vela is a supportive companion for reflection and journaling. It is not a substitute for professional
              mental health care. If you are experiencing a mental health crisis, please contact a licensed professional
              or call 988 (US Crisis Lifeline).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-serif font-semibold text-stone-800 mb-3">User Responsibility</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>You are responsible for keeping your passcode secure.</li>
              <li>We cannot recover your data if you forget your passcode.</li>
              <li>You agree to use AraVela in accordance with applicable laws.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-serif font-semibold text-stone-800 mb-3">Autonomy-First Design</h2>
            <p>
              AraVela is designed to respect your autonomy. Nothing is saved unless you explicitly
              tap Save to Diary. You control what data is stored, exported, or deleted. Turning on
              Auto Check-In Alerts is a separate, explicit choice that permits a minimal local
              marker (timestamp and intensity, never your messages) so Vela can offer a gentle
              follow-up.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-serif font-semibold text-stone-800 mb-3">No Warranty</h2>
            <p>
              AraVela is provided "as is" without warranty of any kind. We do not guarantee that the service will
              be uninterrupted, error-free, or secure.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-serif font-semibold text-stone-800 mb-3">Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, we are not liable for any damages arising from your use
              of AraVela, including but not limited to data loss, emotional distress, or reliance on AI-generated content.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-serif font-semibold text-stone-800 mb-3">Intellectual Property</h2>
            <p>
              All content you create within AraVela is your intellectual property. We claim no ownership over your
              diary entries, reflections, or patterns.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-serif font-semibold text-stone-800 mb-3">Changes to Terms</h2>
            <p>
              We may update these terms from time to time. Continued use of AraVela after changes constitutes
              acceptance of the updated terms.
            </p>
          </section>

          <section className="pt-4 border-t border-stone-200">
            <p className="text-sm text-stone-500">
              Last updated: January 2026
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;